/**
 * @ngdoc controllers
 * @memberof mercury.modules.stock
 * @name StockPositemlinkEditCtrl
 */
angular.module('mercury.modules.stock.positemlink')
.controller('StockPositemlinkEditCtrl', ["dialog", "$filter", "$q", "$scope", "$state", "$stateParams", "StockRecipes", function(dialog, $filter, $q, $scope, $state, $stateParams, StockRecipes) {
  /**
  * Based on the current tab and item group, is the input item visible
  *
  * @return {Boolean} true if the item is visible, otherwise false.
  */
  var itemVisible = function(item) {
    var groupMatches = [item.itemGroupName, item.itemCategoryName, item.revenueGroup].indexOf($stateParams.groupName) !== -1;
    switch ($scope.activeTab) {
      case 'linked':
        return groupMatches && angular.isDefined(item.currentLink.stockId) && item.currentLink.stockId !== null;
      case 'unlinked':
        return groupMatches && !item.currentLink.stockId;
    }
  };

  $scope.initalLoadPromise.then(function() {
    if (!$stateParams.groupName) {
      $state.go('.', {groupName: $scope.groups[0]});
      return;
    }

    $scope.activeTab = ($state.current.name == 'Stock.PosItemLink.Linked') ? 'linked' : 'unlinked';

    $scope.visibleItems = $filter('filter')($scope.posItems, itemVisible);
    $scope.visibleItems = $filter('orderBy')($scope.visibleItems, 'name');
  });

  $scope.$on('$stateChangeStart', function(event, toState, toParams) {
    var pendingChanges = false;
    angular.forEach($scope.visibleItems, function(posItem) {
      pendingChanges = pendingChanges || posItem.pending;
    });

    if (pendingChanges) {
      event.preventDefault();

      dialog.confirm('Not all changes to your POS links have been saved. Do you want to continue?')
      .then(function(confirmed) {
        if (confirmed) {
          // Revert the pending changes and contine to the requested state.
          angular.forEach($scope.visibleItems, function(posItem) {
            posItem.pending = false;
            posItem.currentLink = $scope.findCurrentLink(posItem.history);
          });

          $state.go(toState, toParams);
        }
      });
    }
  });

  $scope.linkItemSet = function(item, newStockitem) {
    item.currentLink.stockDeleted = false;

    if (!newStockitem) {
      item.currentLink.recipeId = null;
      item.currentLink.stockItemId = null;
      item.currentLink.unitId = null;
      item.currentLink.unitName = null;
      item.currentLink.unitRatio = null;
      item.currentLink.currentPrice = null;
      item.currentLink.quantity = 0;
    } else {
      if (newStockitem.group == 'Recipes') {
        StockRecipes.getCostAndUnit(newStockitem.id)
        .then(function(result) {
          item.currentLink.recipeId = newStockitem.id;
          item.currentLink.stockItemId = null;
          item.currentLink.unitId = result.currentVersion.yeildUnitId;
          item.currentLink.unitName = result.currentVersion.yeildUnitName;
          item.currentLink.unitRatio = result.currentVersion.yeildUnitRatio;
          item.currentLink.currentPrice = result.currentPrice;
          item.currentLink.quantity = 1 * item.currentLink.unitRatio;
        });
      } else {
        item.currentLink.recipeId = null;
        item.currentLink.stockItemId = newStockitem.id;
        item.currentLink.unitId = newStockitem.unitId;
        item.currentLink.unitName = newStockitem.unitName;
        item.currentLink.unitRatio = newStockitem.unitRatio;
        item.currentLink.currentPrice = newStockitem.currentPrice;
        item.currentLink.quantity = 1 * item.currentLink.unitRatio;
      }
    }

    item.pending = true;
  };

  $scope.linkUnitSet = function(item, newUnit) {
    item.currentLink.quantity = (item.currentLink.quantity / item.currentLink.unitRatio) * newUnit.ratio;
    item.currentLink.unitRatio = newUnit.ratio;

    item.pending = (item.currentLink.recipeId !== null || item.currentLink.stockItemId !== null) && item.currentLink.unitId !== null;
  };

  $scope.linkQuantitySet = function(item) {
    item.pending = true;
  };

  /**
  * Call back for changing one of the pos item links
  */
  $scope.linkSave = function(updatedItem, index) {
    if ($scope.posLinksForm['quantity' + index].$invalid) {
      return;
    }

    var createNew = !updatedItem.currentLink.datestampUpdated || moment(updatedItem.currentLink.datestampUpdated).isBefore(moment().subtract(1, 'days'));
    updatedItem.currentLink.posIdentifier = updatedItem.posIdentifier;

    updatedItem.saving = $scope.linkUpdated(updatedItem.currentLink, createNew);
    updatedItem.saving.then(function() {
      angular.forEach($scope.visibleItems, function(posItem, posItemIndex) {
        if (posItem.posIdentifier == updatedItem.posIdentifier && itemVisible(updatedItem) === false) {
          $scope.visibleItems.splice(posItemIndex, 1);
        }
      });
    });
  };

  $scope.currentPrice = function(posItem) {
    if (posItem.currentLink && posItem.currentLink.quantity) {
      return posItem.currentLink.currentPrice * posItem.currentLink.quantity;
    } else {
      return 0;
    }
  };

  $scope.cogs = function(posItem) {
    if (posItem.price && posItem.currentLink && posItem.currentLink.quantity) {
      return ($scope.currentPrice(posItem) / posItem.priceEx) * 100;
    } else {
      return 0;
    }
  };

  /**
  * Open a modal to show the link history for the input POS item
  */
  $scope.showHistory = function(item, index) {
    $scope.historyItem = item;
    $scope.historyItemIndex = index;

    dialog.open({
      templateUrl: 'modules/stock/positemlink/history.tpl.html',
      scope: $scope,
      size: 'lg'
    });
  };

  $scope.updateHistory = function(linkIndex) {
    $scope.linkUpdated($scope.historyItem.history[linkIndex], false);
  };

  $scope.deleteHistory = function(linkIndex) {
    $scope.historyItem.history[linkIndex].deleted = true;
    $scope.linkUpdated($scope.historyItem.history[linkIndex], false)
    .then(function() {
      if (itemVisible($scope.historyItem) === false) {
        $scope.visibleItems.splice($scope.historyItemIndex, 1);
      }
    });
  };
}]);
